import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useRequestAppAccess() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: ({ id }: { id: string }) =>
      api.post('/api/v1/applications/request-access/:id', void 0, { params: { id } }),
    successLogAction: (input) => ({ ActionType: ActionType.RequestAccess, Option: input.id }),
    errorLogAction: (input) => ({ ActionType: ActionType.RequestAccess, Option: input.id }),
    onSuccess: () => {
      toast.show('success', t('Common.SnackBar.AppAccessRequested'));
    },
  });
}
